/**
 * @title cot.js: module for Criteo One Tag integration
 * @description TODO: Add some description here
 * @dependency
 */
define([], function() {

	var COT = {
		
		fireEvent: function(data) {
			let options = {
				timeout: 3000,
			}
			$.cachedScript(data.scriptSrc, options).done(function() {

				//console.log('Criteo input data:');
				//console.log(data);
				
				var pushArguments = [];

				if (data.uat === 'true') {
					pushArguments.push({ event: "setUat", uat: 1 });
				}

				if (data.account) {
					pushArguments.push({ event: "setAccount", account: data.account });
				}

				if (data.retailerVisitorId) {
					pushArguments.push({ event: "setRetailerVisitorId", id: data.retailerVisitorId });
				}
				if (data.email) {
					pushArguments.push({ event: "setEmail", email: data.email });
				}
				let args;
				if (data.event === 'viewHome') {
					args = COT.createHomeArgs(data);

				} else if (data.event === 'viewBasket') {
					args = COT.createBasketArgs(data);

				} else if (data.event === 'trackTransaction') {
					args = COT.createOrderConfirmationArgs(data);

				} else if (data.event === 'viewItem') {
					args = COT.createPDPArgs(data);

				} else if (data.event === 'viewSearchResult') {
					args = COT.createSearchResultArgs(data);

				} else if (data.event === 'viewCategory') {
					args = COT.createCategoryArgs(data);

				} else if (data.event === 'addToCart') {
					args = COT.createAddToCartArgs(data);
					
				} else if (data.event === 'viewPharmacy') {
					args = COT.createCMPPArgs(data);
				}

				if (args) {
					pushArguments.push(args);
					window.criteo_q = window.criteo_q || [];
					try {
						window.criteo_q.push(pushArguments);

						//console.log('Criteo event data:');
						//console.log(pushArguments);
						console.log('Criteo event has been fired succesfully');
					}
					catch (err) {
						console.error(err.message);
					}
				}

			}).fail(function() {
				console.log('Unable to call Criteo Loader. Script path: ' + data.scriptSrc);
			});

		},
		createHomeArgs: function(data) {
			let args = {
					event: data.event,
					page_id: data.pageId
				}
			if (COSTCO.util.isBDStore()) args.store_id = data.storeId;
			if(data.call_rmp == "true") args.call_rmp = data.call_rmp;
			if(COSTCO.util.isCAStore()) args.block = COT.blockUserTracking();
			
			return args;
		},
		createCMPPArgs: function(data) {
			let args = {
					event: data.event,
					page_id: data.pageId
				}
			if (COSTCO.util.isBDStore()) args.store_id = data.storeId;
			if(data.call_rmp == "true") args.call_rmp = data.call_rmp;
			if(COSTCO.util.isCAStore()) args.block = COT.blockUserTracking();

			return args;
		},
		createBasketArgs: function(data) {
			let args = {
				event: data.event,
				item: data.item,
				page_id: data.pageId
				}
			if(data.zipCode) {
				args.zipCode = data.zipCode;
			}
			if(data.call_rmp == "true") args.call_rmp = data.call_rmp;
			if(COSTCO.util.isCAStore()) args.block = COT.blockUserTracking();

			return args;
		},
		createOrderConfirmationArgs: function(data) {
			let args = {
					event: data.event,
                    id: data.orderId,
                    item: data.item,
                    page_id: data.pageId
			}

			if(data.call_rmp == "true") args.call_rmp = data.call_rmp;
			if(COSTCO.util.isCAStore()) args.block = COT.blockUserTracking();
			
			return args;
		},
		createPDPArgs: function(data) {
			let decodedPrice = window.atob(data.price);
			let args = {
				event: data.event,
				item: data.item,
				price: decodedPrice,
				availability: data.availability,
				page_id: data.pageId
				}
			if (COSTCO.util.isBDStore()) args.store_id = data.storeId;
			if(data.call_rmp == "true") args.call_rmp = data.call_rmp;
			if(COSTCO.util.isCAStore()) args.block = COT.blockUserTracking();
			
			return args;
		},
		createSearchResultArgs: function(data) {
			let args = { 
				event: data.event,
				item: data.item,
				page_number: data.pageNumber,
				keywords: data.keywords,
				filters: data.filters,
				page_id: data.pageId
			}
			if (COSTCO.util.isBDStore()) args.store_id = data.storeId;
			if(data.call_rmp == "true") args.call_rmp = data.call_rmp;
			if(COSTCO.util.isCAStore()) args.block = COT.blockUserTracking();

			return args;
		},
		createCategoryArgs: function(data) {
			let args = {
				event: data.event,
				category: data.category,
				page_id: data.pageId,
				item: data.item
			}

			if (COT.isBrowse(data.pageId))  {
				args.page_number = data.pageNumber;
				args.filters = data.filters;
			}
			if (COSTCO.util.isBDStore()) args.store_id = data.storeId;
			if(data.call_rmp == "true") args.call_rmp = data.call_rmp;
			if(COSTCO.util.isCAStore()) args.block = COT.blockUserTracking();
			
			return args;
		},
		isBrowse: function(pageId) {
			return (pageId && pageId.startsWith('viewCategory')) ? true : false;
		},
		createAddToCartArgs: function(data) {
			let args = [];
			args.push ({
				event: data.event,
				item: [{
                       id: data.itemId,
                       price: data.price,
                       quantity: data.quantity
				       }]
			});

			if(COSTCO.util.isCAStore()){ 
            	args.push({ event: "setBlock", block: COT.blockUserTracking() });
			}
			if (data.zipCode) {
                args.push({ event: "setZipCode", zipcode: data.zipCode });
			}
            if (data.storeId) {
                args.push({ event: "setStore", storeid: data.storeId });
			}
            if(data.call_rmp == "true"){ 
            	args.push({ event: "setCallRmp", call_rmp: data.call_rmp });
            }

			return args;
		},
		getRetailerVisitorId: function() {
			let csIDName = 'CriteoSessionUserId';
			let csId = '';
			if(COT.blockUserTracking() === '1'){
				//if userTracking is disabled, then return generic retail visitor identifier
				return '0';
			}
			//get from storage if exists else check if a cookie exist and use the value from that
			//if there are no previously generated id, then create one
			let csValue = localStorage.getItem(csIDName);
			if(csValue == null){
				csValue = COT.getCSValueFromCookieAndPersistInStorage();
			}
			//Criteo session value can contain email id with it.
			let csValues = csValue.split(",");
			if(csValue != null){
				csId = csValues[0];
			}
			return csId;
			
	    },
	    getEmail: function() {
			let email = "";
			let csIDName = 'CriteoSessionUserId';
			let csValue = localStorage.getItem(csIDName);
			if(csValue == null){
				csValue = COT.getCSValueFromCookieAndPersistInStorage();
			}
			let csValues = csValue.split(",");
			if (csValues.length > 1) {
				email = csValues[1];
			}
	    	return email;
	    },
	    
	    /**
	     * Generate Criteo session tracking cookie if not available
	     */
	    generateCriteoCookie: function() {
	    	let randomString = COSTCO.util.createUUID();
	    	let csIDName = 'CriteoSessionUserId';
	    	$.cookie(csIDName, randomString, { expires: 30, path:'/' });
	    	return randomString;
	    },
	    getCSValueFromCookieAndPersistInStorage: function(){
	    	let csIDName = 'CriteoSessionUserId';
	    	let csValue = $.cookie(csIDName);
			if(csValue == null){
				//if cookie is null then create new
				csValue =  COT.generateCriteoCookie();
			}
			if(localStorage){
				localStorage.setItem(csIDName,csValue);
			}
			return csValue;
	    }, 
	    blockUserTracking: function() {
	    	let blockUserTracking = "0";
	    	
	    	if(typeof costcoConsentManager === 'undefined'){
	    		blockUserTracking = "1";
	    	} else if(COSTCO.util.isCAStore() && !costcoConsentManager.isConsented('C0004')){
	    		blockUserTracking = "1";
	    	}
	    	
	    	return blockUserTracking;
	    }
		
	};

	if (typeof window.COSTCO == 'undefined') {
		window.COSTCO = new Object();
	}

	window.COSTCO.COT = COT;
	return COT;
});


// WEBPACK FOOTER //
// ./js/global/cot.js